import { render, staticRenderFns } from "./RelatorioOfertasTitulo.vue?vue&type=template&id=fc9053b0"
import script from "./RelatorioOfertasTitulo.vue?vue&type=script&lang=js"
export * from "./RelatorioOfertasTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports